window.addEventListener('DOMContentLoaded', () => {
	if( !document.body.classList.contains('single-reference') )  return;
	const related = document.querySelector('.related-posts-wrapper');
	if(!!!related) return;
	const inner = related.querySelectorAll('.wp-block-jcore-latest-posts__inner .tease');
	if(inner.length === 0) {
		related.style.display = "none";
	}
});
